import * as moment from 'moment'
import { roleuser } from '@edulastic/constants'

export const DEFAULT_ASSIGNMENT_DUE_DAYS = 7
export const DEFAULT_ADMIN_ASSIGNMENT_DUE_DAYS = 28
export const DEFAULT_ASSIGNMENT_DUE_HOUR = 21 // 9:00 PM

export const setDefaultAssignmentDueTime = (date) =>
  moment(date)
    .hour(DEFAULT_ASSIGNMENT_DUE_HOUR)
    .minute(0)
    .second(0)
    .millisecond(0)

export const getDefaultAssignmentDueDate = (
  fromDate = moment(),
  days = DEFAULT_ASSIGNMENT_DUE_DAYS
) => setDefaultAssignmentDueTime(moment(fromDate).add(days, 'days'))

/** Teachers: +7 days; admins: +28 days — both at 9:00 PM. */
export const getDefaultAssignmentDueDateForRole = (
  userRole,
  fromDate = moment()
) => {
  const days =
    userRole !== roleuser.TEACHER
      ? DEFAULT_ADMIN_ASSIGNMENT_DUE_DAYS
      : DEFAULT_ASSIGNMENT_DUE_DAYS
  return getDefaultAssignmentDueDate(fromDate, days)
}
